import PropTypes from 'prop-types';
import { translationPropType } from '@eventbrite/i18n';

export const BULK_ACTIONS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        action: PropTypes.string,
        label: translationPropType,
    }),
);
